export default __webpack_public_path__ + "static/media/PrispekZoom.ec9b2422.jpg";